import axios from "axios";
import { getToken } from "./auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PLANS = [
  {
    id: "monthly",
    label: "Mensual",
    price: 99,
    currency: "MXN",
    perMonth: 99,
    description: "Acceso completo, mes a mes",
    badge: null,
  },
  {
    id: "yearly",
    label: "Anual",
    price: 799,
    currency: "MXN",
    perMonth: Math.round((799 / 12) * 10) / 10,
    description: "Ahorras ~33% pagando un año",
    badge: "Más popular",
  },
];

function authHeader() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function fetchEntitlement() {
  if (!getToken()) return null;
  const { data } = await axios.get(`${API}/billing/me`, { headers: authHeader() });
  return data;
}

export async function validateCoupon(code, plan) {
  const { data } = await axios.post(
    `${API}/billing/validate-coupon`,
    { code, plan },
    { headers: authHeader() }
  );
  return data;
}

export async function createCheckout(plan, promotionCode) {
  const origin = window.location.origin;
  const { data } = await axios.post(
    `${API}/billing/checkout`,
    { plan, origin_url: origin, promotion_code: promotionCode || null },
    { headers: authHeader() }
  );
  return data; // {url, session_id, promotion_code}
}

export async function fetchCheckoutStatus(sessionId) {
  const { data } = await axios.get(`${API}/billing/status/${sessionId}`, {
    headers: authHeader(),
  });
  return data;
}

export async function fetchTransactions() {
  const { data } = await axios.get(`${API}/billing/transactions`, { headers: authHeader() });
  return data.transactions || [];
}

export const SUPPORT_EMAIL = "mariana.flores@mateconmar.com";

export async function startRound() {
  // For guest users (no token), we let the frontend handle the daily limit locally.
  if (!getToken()) return { allowed: true, entitlement: null, guest: true };
  const { data } = await axios.post(`${API}/practice/round-start`, {}, { headers: authHeader() });
  return data;
}

// ----- Guest-mode local rate limit (mirrors free-tier 1/day) -----
const GUEST_KEY = "mateconmar.guestDaily";

function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function guestRoundsToday() {
  try {
    const raw = localStorage.getItem(GUEST_KEY);
    if (!raw) return 0;
    const obj = JSON.parse(raw);
    return obj.date === todayStr() ? obj.count || 0 : 0;
  } catch {
    return 0;
  }
}

export function recordGuestRound() {
  const today = todayStr();
  const current = guestRoundsToday();
  try {
    localStorage.setItem(GUEST_KEY, JSON.stringify({ date: today, count: current + 1 }));
  } catch {}
  return current + 1;
}

export const FREE_DAILY_LIMIT = 1;
